import Vue from 'vue'

import * as types from './mutation_types'

export default {
  [types.SET_PROJECT](state, payload) {
    for ( let k in payload ){
    	Vue.set(state.project, k, payload[k])
    }
  },

  [types.SET_PROJECT_VALUES](state, payload) {
    for ( let k in payload ){
    	if((!!payload[k] && !!state.project[k]) || payload[k] === 0){
    		const obj = {
	    		...state.project[k],
	    	}

	    	obj.value = payload[k]

	    	Vue.set(state.project, k, obj)
    	}
    }
  }
}
